<template>
  <swiper :options="swiperOption" class="swiper">
    <swiper-slide v-for="(item, index) in bannerData" :key="index">
      <img :src="item" alt="" class="swiperImg" />
    </swiper-slide>
    <div slot="pagination" class="swiper-pagination"></div>
    <div slot="button-prev" class="swiper-button-prev swiper-button-white"></div>
    <div slot="button-next" class="swiper-button-next swiper-button-white"></div>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import http from '@/http/index';

export default {
  name: 'BannerSwiper',
  data () {
    return {
      // 默认 fallback 图片（必须用 require 引入）
      defaultBanners: [
        require('@/assets/images/banner.png')
      ],
      bannerData: [],
      swiperOption: {
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        loop: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          bulletActiveClass: 'bulletActiveClass'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },
  created () {
    this.fetchBannerData();
  },
  methods: {
    fetchBannerData () {
      const abbr = window.localStorage.getItem('pcs_org_abbr');

      // 如果 abbr 无效，直接使用默认图
      if (!abbr || typeof abbr !== 'string' || abbr.trim() === '') {
        this.bannerData = [...this.defaultBanners];
        return;
      }

      // 否则发起请求
      http.getBannerImg({ abbr: abbr.trim() })
        .then(res => {
          // 安全校验响应结构
          if (res.data.data && Array.isArray(res.data.data.imageUrlList)) {
            const imageUrlList = res.data.data.imageUrlList;

            // 注意：你原代码中 splice(1, ...) 是跳过第一张图？
            // 如果是故意跳过首图（比如首图用于 logo），保留逻辑
            let swiperBanner = imageUrlList.slice(1); // 更安全的写法（不用 splice 修改原数组）

            if (swiperBanner.length > 0) {
              this.bannerData = swiperBanner;
            } else {
              // 接口返回了列表但只有 1 张或空，fallback 到默认图
              this.bannerData = [...this.defaultBanners];
            }

            // 更新机构名称（注意：你原代码读的是 localStorage，但应该用接口返回的！）
            if (res.data.data.orgName) {
              this.$store.state.name = res.data.data.orgName;
              // 可选：也存入 localStorage
              // localStorage.setItem('pcs_org_name', res.data.data.orgName);
            }
          } else {
            // 接口返回格式异常，兜底
            this.bannerData = [...this.defaultBanners];
          }
        })
        .catch(err => {
          console.warn('获取轮播图失败:', err);
          this.bannerData = [...this.defaultBanners]; // 请求失败，用默认图
        });
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
};
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 450px;
}

::v-deep .bulletActiveClass {
  background: $el-main-color;
  opacity: 1;
}

::v-deep .swiper-button-prev,
::v-deep .swiper-button-next {
  width: 40px;
  height: 75px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}

::v-deep .swiper-button-prev:hover,
::v-deep .swiper-button-next:hover {
  background: rgba(0, 0, 0, 0.4);
}

::v-deep .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.swiperImg {
  width: 100%;
  height: 450px;
  object-fit: cover; // 推荐加上，避免图片变形
}
</style>



// WEBPACK FOOTER //
// src/components/index/swiperBanner.vue